import { gql, useMutation } from '@apollo/client';
import { NewsPost } from 'apollo/generated/types';
import { LocalizedCreateNewsPostInput } from 'apollo/localizedTypes';

const CREATE_NEWS_POST = gql`
  mutation createNewsPost($input: CreateNewsPostInput!) {
    createNewsPost(input: $input) {
      id
    }
  }
`;

const useCreateNewsPostMutation = () => {
  return useMutation<
    { createNewsPost: NewsPost },
    { input: LocalizedCreateNewsPostInput }
  >(CREATE_NEWS_POST, {});
};
export default useCreateNewsPostMutation;
